import { render, staticRenderFns } from "./InfoAssetBanner.vue?vue&type=template&id=10cbf9fb&scoped=true"
import script from "./InfoAssetBanner.vue?vue&type=script&lang=js"
export * from "./InfoAssetBanner.vue?vue&type=script&lang=js"
import style0 from "./InfoAssetBanner.vue?vue&type=style&index=0&id=10cbf9fb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cbf9fb",
  null
  
)

export default component.exports